import * as React from 'react';
import * as style from './Wrapper.css';
import { clsx } from 'clsx';

interface IProps {
  isModal: boolean;
  isPhone: boolean;
  children: React.ReactNode;
}

export const Wrapper = (props: IProps) => {
  const { isModal, isPhone, children } = props;

  return (
    <div
      className={clsx(
        style['wrapper'],
        isModal && style['modal_wrapper'],
        isPhone && isModal && style['phone_modal_wrapper'],
      )}
    >
      {children}
    </div>
  );
};
